import { render, staticRenderFns } from "./FeriadoManager.vue?vue&type=template&id=0e9234bf&scoped=true"
import script from "./FeriadoManager.vue?vue&type=script&lang=js"
export * from "./FeriadoManager.vue?vue&type=script&lang=js"
import style0 from "./FeriadoManager.vue?vue&type=style&index=0&id=0e9234bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9234bf",
  null
  
)

export default component.exports